// extracted by mini-css-extract-plugin
export default {"storageSpace":"storageSpace___oiiCk"};